import {GenerationType} from "../types/GenerationType.ts";
import {Box} from "@mui/material";
import {VideoIcon} from "./VideoIcon.tsx";
import {MediaSkeleton} from "./MediaSkeleton.tsx";
import {useState} from "react";



interface IGeneratedGalleryCardProps {
    src: string
    alt: string
    type?: GenerationType
    onClick?: () => void
}

export const GeneratedGalleryCard = ({src, alt, onClick, type}: IGeneratedGalleryCardProps) => {
    const [isLoaded, setIsLoaded] = useState(false);

    if (!type) {
        return null
    }

    return (
        <Box position="relative">
            {!isLoaded && (
                <MediaSkeleton
                    width="100%"
                    aspectRatio="1/1"
                    borderRadius="4px"
                />
            )}
            <Box
                component="img"
                src={src}
                alt={alt}
                onClick={onClick}
                onLoad={() => setIsLoaded(true)}
                sx={{
                    width: '100%',
                    maxHeight: 'calc(25vw - 1.5px)',
                    aspectRatio: '1/1',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    objectFit: 'cover',
                    objectPosition: 'top',
                    display: isLoaded ? 'block' : 'none'
                }}
            />
            {type === 'video' && isLoaded && <VideoIcon/>}
        </Box>

    )
};
